'use client';

import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, A11y } from 'swiper/modules';
import Image from 'next/image';
import certificateImage1 from '../../../Assets/certificates/BH-JS-updated.jpg';
import certificateImage2 from '../../../Assets/certificates/CA-UIUX.webp';
import certificateImage3 from '../../../Assets/certificates/OST-Javascript.webp';
import certificateImage4 from '../../../Assets/certificates/PH-Level-1.webp';
import certificateImage5 from '../../../Assets/certificates/Blackbelt-updated.png';
import certificateImage6 from '../../../Assets/certificates/OST-Sopify.webp';
import certificateImage7 from '../../../Assets/certificates/PH-Level-2.webp';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import TitleMain from '@/components/shared/TitleMain/TitleMain';

const Certificates = () => {
  const certificates = [
    certificateImage5,
    certificateImage7,
    certificateImage3,
    certificateImage4,
    certificateImage1,
    certificateImage2,
    certificateImage6,
  ];

  return (
    <section className='certificates-section bg-gradient-to-b from-purple-800 via-blue-800 to-blue-900 text-white py-20 px-4 sm:px-6 lg:px-8'>
      <div className='max-w-7xl mx-auto'>
        <TitleMain
          text='My Certificates'
          className='text-purple-400 mb-12 text-center'
        />

        <div className='relative group'>
          <Swiper
            loop
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            navigation={{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }}
            spaceBetween={30}
            slidesPerView={1}
            modules={[Navigation, Autoplay, A11y]}
            breakpoints={{
              640: { slidesPerView: 1 },
              1024: { slidesPerView: 2 },
              1280: { slidesPerView: 3 },
            }}
            a11y={{
              prevSlideMessage: 'Previous certificate',
              nextSlideMessage: 'Next certificate',
              firstSlideMessage: 'This is the first certificate',
              lastSlideMessage: 'This is the last certificate',
            }}
            className='pb-16'
          >
            {certificates.map((certificate, index) => (
              <SwiperSlide key={index}>
                <div className='relative aspect-[4/3] bg-gray-900/20 rounded-xl overflow-hidden transform transition-all hover:scale-95 hover:shadow-xl'>
                  <Image
                    src={certificate}
                    alt={`Certificate ${index + 1}`}
                    fill
                    className='object-contain p-4'
                    placeholder='blur'
                    sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw'
                  />
                </div>
              </SwiperSlide>
            ))}

            {/* Custom Navigation Buttons */}
            <div className='swiper-button-prev !text-purple-700 hover:!text-white !scale-75 lg:!scale-100 !transition-all' />
            <div className='swiper-button-next !text-purple-700 hover:!text-white !scale-75 lg:!scale-100 !transition-all' />
          </Swiper>

          {/* Gradient Overlay */}
          <div className='absolute inset-0 pointer-events-none bg-gradient-to-r from-purple-900/30 via-transparent to-purple-900/30' />
        </div>
      </div>
    </section>
  );
};

export default Certificates;
